import { Component, Input, input, InputSignal, model, ModelSignal } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonLoaderComponent } from '@shared/components/ui/skeleton-loader';
import { CommonModule } from '@angular/common';

type TState = 'default' | 'disabled';

@Component({
  selector: 'lib-support-message',
  templateUrl: './support-message.component.html',
  styleUrl: './support-message.component.css',
  standalone: true,
  imports: [TranslateModule, SkeletonLoaderComponent, CommonModule],
})
export class SupportMessageComponent {

  /**
   * The color class to apply to the support message.
   * @default 'danger'
   */
  public readonly colorClass: InputSignal<string> = input<string>('danger');

  /**
   * The message to display.
   */
  public readonly message: InputSignal<string> = input<string>();

  /**
   * Errors to display.
   */
  @Input() public set errors(errors: ValidationErrors | null){
    this.errorMessage = null;
    this.errorObj = null;
    if (errors) {
      for (const error of this.errorsDefault) {
        const key = error[0];
        const errorValue = errors[key];
        if (errorValue) {
          this.errorMessage = error[1];
          this.errorObj = typeof errorValue === 'object' ? errorValue : null;
          break;
        }
      }
    }
  }

  /**
   * The position of the support message.
   */
  public readonly position: InputSignal<string> = input<string>('start');

  public errorObj: any;
  public errorMessage: string;
  public errorsDefault: Array<Array<string>> = [
    ['required', 'FORMS.FIELD_MUST_BE_FILLED'],
    ['email', 'FORMS.INVALID_EMAIL'],
    ['minlength', 'FORMS.MIN_LENGTH'],
    ['maxlength', 'FORMS.MAX_LENGTH'],
    ['pattern', 'FORMS.PATTERN'],
    ['invalidDate', 'FORMS.INVALID_DATE'],
    ['minDate', 'FORMS.MIN_DATE'],
    ['maxDate', 'FORMS.MAX_DATE'],
    ['minTime', 'FORMS.MIN_TIME'],
    ['maxTime', 'FORMS.MAX_TIME'],
    ['minStartDate', 'FORMS.MIN_START_DATE'],
    ['maxStartDate', 'FORMS.MAX_START_DATE'],
    ['minEndDate', 'FORMS.MIN_END_DATE'],
    ['maxEndDate', 'FORMS.MAX_END_DATE'],
    ['min', 'FORMS.MIN'],
    ['max', 'FORMS.MAX'],
    ['invalidTime', 'COMPONENTS.TIMEPICKER.INVALID_TIME'],
    ['invalidUrl', 'COMPONENTS.VALIDATION.INVALID_URL'],
    ['startDateGtEndDate', 'FORMS.START_DATE_GT_END_DATE'],
    ['timeGt', 'FORMS.START_TIME_GT_END_TIME'],
    ['timeLt', 'FORMS.END_TIME_LT_START_TIME'],
  ];

  public readonly skeleton: InputSignal<boolean> = input<boolean>(false);


  /**
   * Visual state of the component. This can be used to apply specific styling based on the state
   *
   * @default 'default'
   */
  public readonly state: ModelSignal<TState> = model<TState>('default');

}
